import { createAction } from '@reduxjs/toolkit';
import type { Filters } from '@lt/api/dist/methods/explore/types';

import { GET_PREVIOUS_FILTERS, SET_PREVIOUS_FILTERS } from './constants';

export const getPreviousFiltersAction = createAction(GET_PREVIOUS_FILTERS);

export const setPreviousFiltersAction =
  createAction<Partial<Filters>>(SET_PREVIOUS_FILTERS);
